import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

const INACTIVITY_LIMIT = 10 * 60 * 1000; // 10 minutos en milisegundos
let lastActivity = Date.now();

// 🔁 Registrar eventos de actividad (solo una vez)
if (!(window as any)._activityListenerSet) {
  ['mousemove', 'keydown', 'click', 'scroll'].forEach(event => {
    window.addEventListener(event, () => (lastActivity = Date.now()));
  });
  (window as any)._activityListenerSet = true; // Evita registrar duplicados
}

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authUser = localStorage.getItem('authUser');
  const now = Date.now();

  // 1️⃣ Si no hay usuario autenticado → redirigir al login
  if (!authUser) {
    router.navigate(['/signin']);
    return false;
  }

  // 2️⃣ Verificar inactividad (sin eventos durante 10 minutos)
  if (now - lastActivity > INACTIVITY_LIMIT) {
    console.warn('Sesión cerrada por inactividad');
    localStorage.removeItem('authUser');
    router.navigate(['/signin']);
    return false;
  }

  // 3️⃣ Si todo bien → permitir el acceso
  return true;
};
